import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { ScoringFragmentDoc } from '../../../../pages/graphql/fragments/Scoring.fragment';
import { TitleOfferLightFragmentDoc } from '../../../buybox/graphql/fragments/Offer.fragment';
export type AdServerSqtvCreativeFragment = {
	__typename: 'CreativeSQTVContent';
	offerSource?: Types.OfferSource | null;
	similarityScore: number;
	offer: { __typename?: 'Offer'; id: string; package: { __typename?: 'Package'; shortName: string } };
	similarTitle: {
		__typename: 'AdSimilarTitle';
		id: string;
		objectId: number;
		objectType: Types.ObjectType;
		content: {
			__typename: 'AdSimilarTitleContent';
			title: string;
			posterUrl?: string | null;
			fullPath: string;
			backdrops: Array<{ __typename: 'Backdrop'; backdropUrl: string }>;
			scoring?: {
				__typename: 'Scoring';
				imdbScore?: number | null;
				imdbVotes?: number | null;
				tmdbPopularity?: number | null;
				tmdbScore?: number | null;
				jwRating?: number | null;
				tomatoMeter?: number | null;
				certifiedFresh?: boolean | null;
				hideJWRating: boolean;
			} | null;
			interactions: { __typename: 'InteractionAttributes'; votesNumber: number };
			genres: Array<{ __typename: 'Genre'; translation: string }>;
			tags: Array<{ __typename: 'Tag'; technicalName: string; translatedName: string }>;
		};
		offers: Array<{
			__typename: 'Offer';
			id: string;
			monetizationType: Types.MonetizationType;
			presentationType: Types.PresentationType;
			standardWebURL?: string | null;
			mediaDealId?: number | null;
			streamUrl?: string | null;
			country: any;
			package: {
				__typename: 'Package';
				id: string;
				packageId: number;
				clearName: string;
				shortName: string;
				icon: string;
				iconWide: string;
				maskReferrer?: boolean | null;
				technicalName: string;
			};
		}>;
	};
};

export const AdServerSqtvCreativeFragmentDoc = gql`
	fragment AdServerSQTVCreative on CreativeSQTVContent {
		offerSource
		similarityScore
		offer {
			id
			package {
				shortName
			}
		}
		similarTitle {
			id
			objectId
			objectType
			content {
				title
				posterUrl
				fullPath
				backdrops(limit: 1) {
					backdropUrl
					__typename
				}
				scoring {
					...Scoring
					__typename
				}
				interactions {
					votesNumber
					__typename
				}
				genres {
					translation(language: $language)
					__typename
				}
				tags {
					technicalName
					translatedName
					__typename
				}
				__typename
			}
			offers(country: $country, platform: $platform) {
				...TitleOfferLight
				__typename
			}
			__typename
		}
		__typename
	}
	${ScoringFragmentDoc}
	${TitleOfferLightFragmentDoc}
`;
